// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1ybzs","calendarButtons":"ClockData_calendarButtons__AtQpZ"};